/**
 * Chore scheduling — server-driven status types and countdown formatting.
 * All scheduling logic now lives on the server (scheduler.ts).
 * The client only reads PendingChores status + timestamps from the API.
 */

export type ChoreStatus = "pending" | "due" | "completed" | "failed";

/**
 * Format milliseconds into human-friendly time string.
 */
export function formatTimeRemaining(ms: number): string {
  if (ms <= 0) return "0s";
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 24) {
    const days = Math.floor(hours / 24);
    const remHours = hours % 24;
    return remHours > 0 ? `${days}d ${remHours}h` : `${days}d`;
  }
  if (hours > 0) return `${hours}h ${minutes}m`;
  if (minutes > 0) return `${minutes}m ${seconds}s`;
  return `${seconds}s`;
}
